$(document).ready(function () {
   if ($('#preloader-background').length > 0) {
        setTimeout(function() {
            $('#preloader-background').hide();
          // $(".hero-video").addClass("transition-class");
        }, 1500); // 1000 milliseconds = 1 second
    };
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const IS_FR = document.documentElement.lang === "fr";

 
// ===============================
// 1. ALL RESULTS (54 COMBINATIONS)
// ===============================
const resultMap = {

  "A-A-A": "dacha",
  "A-A-B": "jetty",
  "A-A-C": "lakeside",
  "A-A-D": "nassau",
  "A-A-E": "serpentia",
  "A-A-F": "mamba",

  "A-B-A": "larvotto",
  "A-B-B": "urban",
  "A-B-C": "nolo",
  "A-B-D": "nolo",
  "A-B-E": "serpentia",
  "A-B-F": "nolo",

  "A-C-A": "anatolia",
  "A-C-B": "anatolia",
  "A-C-C": "mamba",
  "A-C-D": "nassau",
  "A-C-E": "serpentia",
  "A-C-F": "mamba",

  "B-A-A": "dacha",
  "B-A-B": "jetty",
  "B-A-C": "lakeside",
  "B-A-D": "nassau",
  "B-A-E": "lakeside",
  "B-A-F": "mamba",

  "B-B-A": "larvotto",
  "B-B-B": "urban",
  "B-B-C": "nolo",
  "B-B-D": "nolo",
  "B-B-E": "serpentia",
  "B-B-F": "urban",

  "B-C-A": "anatolia",
  "B-C-B": "anatolia",
  "B-C-C": "mamba",
  "B-C-D": "anatolia",
  "B-C-E": "serpentia",
  "B-C-F": "mamba",

  "C-A-A": "mamba",
  "C-A-B": "jetty",
  "C-A-C": "lakeside",
  "C-A-D": "nassau",
  "C-A-E": "serpentia",
  "C-A-F": "larvotto",

  "C-B-A": "larvotto",
  "C-B-B": "urban",
  "C-B-C": "nolo",
  "C-B-D": "nolo",
  "C-B-E": "serpentia",
  "C-B-F": "urban",

  "C-C-A": "anatolia",
  "C-C-B": "jetty",
  "C-C-C": "anatolia",
  "C-C-D": "nassau",
  "C-C-E": "serpentia",
  "C-C-F": "mamba"
};


// ===============================
// 2. ANSWERS STORAGE
// ===============================
let answers = { q1: null, q2: null, q3: null };


// ===============================
// 3. REDIRECT FUNCTION
// ===============================
function redirectToProduct(handle) {
  window.open("/products/" + handle, "_blank");
}

// ===============================
// 4. LOAD QUESTION FUNCTION
// ===============================
function loadQuestion(step) {
  let html = "";

  // Q1
 if (step === 1) {
  html = IS_FR ? `
    <div id="close-question" class="bg-new-blue absolute flex items-center justify-center top-4 right-4 p-5 rounded-[50%] w-[15px] h-[15px] md:w-[30px] md:h-[30px] text-white MaximaNouvaRegular flex items-center justify-center text-3xl md:text-4xl">
      <span>X</span>
    </div>

    <h2 class="text-lg md:text-2xl HeadingNowMedium new-blue mb-8 text-center">
      Quelle est l’humeur qui vous décrit le mieux en ce moment ?
    </h2>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4" data-q="q1" data-v="A">
   Calme & Réflexion
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4" data-q="q1" data-v="B">
      Énergie & Aventure
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4" data-q="q1" data-v="C">
     Élégance & Raffinement
    </button>
  ` : `
    <div id="close-question" class="bg-new-blue absolute flex items-center justify-center top-4 right-4 p-5 rounded-[50%] w-[15px] h-[15px] md:w-[30px] md:h-[30px] text-white MaximaNouvaRegular flex items-center justify-center text-3xl md:text-4xl">
      <span>X</span>
    </div>

    <h2 class="text-lg md:text-2xl HeadingNowMedium new-blue mb-8 text-center">
      What best describes your current mood?
    </h2>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4" data-q="q1" data-v="A">
      Calm & Reflective
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4" data-q="q1" data-v="B">
      Energetic & Adventurous
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4" data-q="q1" data-v="C">
      Elegant & Refined
    </button>
  `;
}

  // Q2
 if (step === 2) {
  html = IS_FR ? `
    <div id="close-question" class="bg-new-blue absolute flex items-center justify-center top-4 right-4 p-5 rounded-[50%] w-[15px] h-[15px] md:w-[30px] md:h-[30px] text-white MaximaNouvaRegular flex items-center justify-center text-3xl md:text-4xl">
      <span>X</span>
    </div>

    <h2 class="text-lg md:text-2xl HeadingNowMedium new-blue mb-8 text-center py-4">
     Où préférez-vous aller ?
    </h2>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4"
      data-q="q2" data-v="A">
      Le calme de la nature
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4"
      data-q="q2" data-v="B">
   	Le rythme urbain
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4"
      data-q="q2" data-v="C">
     Des paysages exotiques
    </button>
  ` : `
    <div id="close-question" class="bg-new-blue absolute flex items-center justify-center top-4 right-4 p-5 rounded-[50%] w-[15px] h-[15px] md:w-[30px] md:h-[30px] text-white MaximaNouvaRegular flex items-center justify-center text-3xl md:text-4xl">
      <span>X</span>
    </div>

    <h2 class="text-lg md:text-2xl HeadingNowMedium new-blue mb-8 text-center py-4">
      Where do you prefer to go?
    </h2>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4"
      data-q="q2" data-v="A">
      Nature’s calm
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4"
      data-q="q2" data-v="B">
      Urban rhythm
    </button>

    <button class="quiz-btn option-btn block w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-base md:text-xl mb-4"
      data-q="q2" data-v="C">
      Exotic landscapes
    </button>
  `;
}


  // Q3
if (step === 3) {
  html = IS_FR ? `
    <div id="close-question" class="bg-new-blue absolute flex items-center justify-center top-4 right-4 p-5 rounded-[50%] w-[15px] h-[15px] md:w-[30px] md:h-[30px] text-white MaximaNouvaRegular flex items-center justify-center text-3xl md:text-4xl">
      <span>X</span>
    </div>

    <h2 class="text-lg md:text-2xl HeadingNowMedium new-blue mb-8 text-center">
     Quel style de parfum vous attire le plus ?
    </h2>

    <div class="!grid grid-cols-2 gap-4">

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="A">
          Fruité & Hespéridé
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="B">
         Chaud & Oriental
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="C">
        Musqué & Propre
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="D">
          Boisé & Terreux
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="E">
          	Gourmand & Sucré
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="F">
          	Ambré & Floral
        </button>
      </div>

    </div>
  ` : `
    <div id="close-question" class="bg-new-blue absolute flex items-center justify-center top-4 right-4 p-5 rounded-[50%] w-[15px] h-[15px] md:w-[30px] md:h-[30px] text-white MaximaNouvaRegular flex items-center justify-center text-3xl md:text-4xl">
      <span>X</span>
    </div>

    <h2 class="text-lg md:text-2xl HeadingNowMedium new-blue mb-8 text-center">
      Which fragrance style draws you most?
    </h2>

    <div class="!grid grid-cols-2 gap-4">

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="A">
          Fruity & Citrusy
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="B">
          Woody & Earthy
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="C">
          Warm & Oriental
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="D">
          Gourmand & Sweet
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="E">
          Musky & Clean
        </button>
      </div>

      <div class="min-w-0">
        <button class="quiz-btn option-btn w-full border border-[#23418A] new-blue px-4 py-2 rounded-[5px] HeadingNowRegular text-sm md:text-base"
          data-q="q3" data-v="F">
          Ambery & Floral
        </button>
      </div>

    </div>
  `;
}




 if (window.innerWidth < 550) {
  $("#mobile-new-question-container").html(html);
} else {
  $("#new-question-container").html(html);
}

  // Handle clicks
  $(".option-btn").on("click", function () {
    const q = $(this).data("q");
    const v = $(this).data("v");

    answers[q] = v;

    if (q === "q1") loadQuestion(2);
    else if (q === "q2") loadQuestion(3);
    else if (q === "q3") {
      const code = `${answers.q1}-${answers.q2}-${answers.q3}`;
      const handle = resultMap[code];
      redirectToProduct(handle);
    }
  });
}


// ===============================
// 5. START QUIZ BUTTON
// ===============================
$("#startQuizBtn").on("click", function () {
  $("#ticket-info").hide();
  if (window.innerWidth < 550) {
   $("#big-div-question").removeClass("hidden");
} else {
    $("#new-question-container").removeClass("hidden");
}

  loadQuestion(1);
});
$(document).on("click", "#close-question", function () {
  $("#ticket-info").show();
  $("#big-div-question").addClass("hidden");
});


  // =========================================================
  // BANNER WITH PRODUCTS — Horizontal Scroll
  // =========================================================
function initBannerScroll() {
  const section = document.querySelector("#banner-scroll-area");
  if (!section) return;

  const slides = section.querySelectorAll("[data-banner-slide]");
  if (!slides.length) return;

  gsap.registerPlugin(ScrollTrigger);

  // Reset all slides
  gsap.set(slides, { x: 0 });

  // Timeline for full-screen sliding
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "+=" + (slides.length * window.innerHeight),
      scrub: true,
      pin: true,
      invalidateOnRefresh: true
    }
  });

  // Each banner slides exactly one screen width (-100vw)
slides.forEach((slide, i) => {

  let isLast = i === slides.length - 1;

  let moveAmount;

  if (isLast) {
    // ⭐ PERFECT FINAL POSITION FOR LAST BANNER
    moveAmount = -40; // adjust between -10vw and -30vw depending on design
  } else {
    // ⭐ Normal movement for all previous banners
    moveAmount = -70 + (i * 1);
  }

  tl.to(slide, {
    x: moveAmount + "vw",
    ease: "none",
    duration: 1
  });

});

}



  // =========================================================
  // FLIP CARDS — Original Animation (preserved exactly)
  // =========================================================
function initFlipCardsScroll() {
  const area = document.querySelector("#flip-cards-area");
  if (!area) return;

  const $cards = $(".story-card");
  gsap.registerPlugin(ScrollTrigger);

  // ---- helper: spacing based on screen width ----
  function getXOffset() {
    const w = window.innerWidth;

    // tablet / small laptop
    if (w < 1200 && w >= 768) {
      return 95; // more horizontal space
    }

    // desktop
    return 120;
  }

  // ---- lazy init ----
  ScrollTrigger.create({
    trigger: area,
    start: "top 90%",
    once: true,
    onEnter: () => {

      const offset = getXOffset();

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: area,
          start: "top top",
          end: () =>
            window.innerWidth < 1200
              ? "+=140%"
              : "+=" + window.innerHeight,
          scrub: true,
          pin: true
        }
      });

      // ---- flip + spread animation ----
      tl.to($cards[0], {
        rotateY: -180,
        xPercent: -offset,
        transformOrigin: "center center",
        ease: "none"
      }, 0);

      tl.to($cards[1], {
        rotateY: -180,
        xPercent: 0,
        transformOrigin: "center center",
        ease: "none"
      }, 0);

      tl.to($cards[2], {
        rotateY: -180,
        xPercent: offset,
        transformOrigin: "center center",
        ease: "none"
      }, 0);

      // ---- floating idle motion ----
      $cards.each(function (i, card) {
        gsap.to(card, {
          y: "+=15",
          rotationZ: i === 1 ? 0 : (i === 0 ? -1 : 1),
          duration: 2 + i,
          yoyo: true,
          repeat: -1,
          ease: "sine.inOut"
        });
      });
    }
  });
}



  // =========================================================
  // INIT ALL GSAP SECTIONS
  // =========================================================
  initBannerScroll();
  initFlipCardsScroll();
 if (window.innerWidth < 768) {

    /* --- Initialize Swiper --- */
const swiper = new Swiper(".mobile-flip-swiper", {
  slidesPerView: 1.1,
  centeredSlides: true,
  initialSlide: 1, // center the second slide
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  slidesOffsetBefore: 40,
  slidesOffsetAfter: 40,

  breakpoints: {
     450: {
      slidesPerView: 1.2, 
      centeredSlides: true, // optional
      initialSlide: 1,       // optional
      spaceBetween: 20
    },
    550: {
      slidesPerView: 1.5, 
      centeredSlides: false, // optional
      initialSlide: 0,       // optional
      spaceBetween: 20
    },
    650: {
      slidesPerView: 2, 
      centeredSlides: false, // optional
      initialSlide: 0,       // optional
      spaceBetween: 20
    }
  }
});


    /* --- Click to flip --- */
    const cards = document.querySelectorAll(".mobile-flip-slide-card");

    cards.forEach(card => {
      card.addEventListener("click", function () {

        // Prevent accidental flip while dragging
        if (swiper.isDragging) return;

        // toggle flip state
        this.classList.toggle("flipped");
      });
    });
  }
});
